import { Disc3, ExternalLink } from "lucide-react";

export default function Header({ status }) {
  const online = status?.online;
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[hsl(224,25%,6%)]/80 border-b border-slate-800/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="relative h-9 w-9 rounded-lg bg-emerald-500/15 border border-emerald-500/40 grid place-items-center">
            <Disc3 className={`h-5 w-5 text-emerald-400 ${online ? "spin-slow" : ""}`} />
          </div>
          <div className="leading-tight">
            <div className="font-heading font-extrabold text-lg tracking-tight" data-testid="app-title">
              SIKE<span className="text-emerald-400">SOUND</span>
            </div>
            <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-slate-500">panel sterowania</div>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <span
            data-testid="bot-status-badge"
            className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-mono border ${
              online ? "border-emerald-500/40 text-emerald-300 bg-emerald-500/10" : "border-red-500/40 text-red-300 bg-red-500/10"
            }`}
          >
            <span className={`h-2 w-2 rounded-full ${online ? "bg-emerald-400 pulse-dot" : "bg-red-400"}`} />
            {online ? "Połączono (Online)" : "Rozłączono (Offline)"}
          </span>
          {status?.invite_url && (
            <a
              href={status.invite_url}
              target="_blank"
              rel="noreferrer"
              data-testid="invite-bot-link"
              className="hidden sm:inline-flex items-center gap-1.5 rounded-full bg-indigo-500 hover:bg-indigo-400 text-white text-xs font-semibold px-4 py-1.5 transition-colors"
            >
              Zaproś bota <ExternalLink className="h-3.5 w-3.5" />
            </a>
          )}
        </div>
      </div>
    </header>
  );
}
